// 미디어 센터 탭 모델 — '전체' 하나 + 섹션 그룹 둘.
//
// 탭은 전부 실제 URL 이다. 클라이언트 state 로 전환하지 않는 이유: 섹션마다
// routes.jsx 의 getStaticPaths 로 프리렌더된 고유 페이지가 있고, sitemap·검색·
// 공유 링크가 전부 그 URL 에 걸려 있다. state 로 바꾸면 전부 /blog 하나로 접힌다.
import { blogPosts, blogSections } from '../../data/blogPosts';

const GROUP_ORDER = ['업무 사례', '메디로이어'];

/** '전체' 탭 — 섹션 슬러그가 없는 /blog. */
export const ALL_TAB = {
  slug: null,
  label: '전체',
  path: '/blog',
  count: blogPosts.length,
};

/** 그룹 순서대로 묶은 섹션 탭. 그룹 사이에는 구분선을 둔다. */
export const TAB_GROUPS = GROUP_ORDER.map((group) => ({
  group,
  tabs: blogSections
    .filter((s) => s.group === group)
    .map((s) => ({ slug: s.slug, label: s.label, path: `/blog/${s.slug}`, count: s.count })),
}));
